import Icon from '@ant-design/icons';
import { FileOutlined } from '@ant-design/icons';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { onlyRecipe } from '../constants/only-recipe.constant';

export const checkCategory = (record, recipe, handle) => {
	if (onlyRecipe[Enviroment.LANGUAGE][record?.prescryption_type])
		return (
			<>
				<span onClick={() => handle(recipe, record)}>
					<Icon style={{ cursor: 'pointer' }} component={FileOutlined} />
				</span>
			</>
		);
	return 'N/A';
};
